import { Route } from "react-router";

export const SentryRoute = Route;
